export default __webpack_public_path__ + "static/media/13.8d780879.jpg";